import React from 'react';

import cx from 'classnames';
import styles from './styles.css';

export default ({ name, price, size }) => (
  <div className={cx(styles.wrap, styles[`wrap_size_${size}`])}>
    {name && <span className={styles.name}>{name}</span>}
    <span className={styles.price}>{renderPrice(price)}</span>
  </div>
);

const renderPrice = (price) => (
  <span className={styles['number-price']}>
    <sup className={styles['price-currency']}>$</sup>
    {price}
    <sup className={styles['price-range']}>/ month</sup>
  </span>
);
